import { UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { PolicyAction, PolicyFormValues } from '../policy-dialog';
import z from 'zod';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';

interface ChangeContactSharingActionProps {
  setValue: UseFormSetValue<PolicyFormValues>;
  watch: UseFormWatch<PolicyFormValues>;
}

export const ChangeContactSharingActionSchema = z.object({
  type: z.literal('Change_Contact_Sharing'),
  contactSharing: z.string(),
});

export type ChangeContactSharingActionType = z.infer<
  typeof ChangeContactSharingActionSchema
>;

// Type guard to check if an action is ChangeContactSharingActionType
function isChangeContactSharingAction(
  action: PolicyAction
): action is ChangeContactSharingActionType {
  return action.type === 'Change_Contact_Sharing';
}

export default function ChangeContactSharingAction({
  setValue,
  watch,
}: ChangeContactSharingActionProps) {
  const actionData = watch('actionData');
  const idx = actionData
    .map((action) => action.type)
    .indexOf('Change_Contact_Sharing');
  const actionAtIndex = actionData[idx];
  if (!isChangeContactSharingAction(actionAtIndex)) {
    return null;
  }

  const currentAction: ChangeContactSharingActionType = actionAtIndex;

  return (
    <Stack>
      <Stack gap={1}>
        <FormControlLabel
          control={
            <Checkbox
              checked={currentAction.contactSharing === 'true'}
              onChange={() =>
                setValue(
                  `actionData.${idx}.contactSharing`,
                  currentAction.contactSharing === 'true' ? 'false' : 'true'
                )
              }
            />
          }
          sx={{ width: 'fit-content' }}
          label="Sharing Enabled"
        />
      </Stack>
    </Stack>
  );
}
